import { LayoutHOC } from 'base/ui/layout/layout';
import createUpdateRoutingOrTransfer from '.';

export const createUpdateRoutingOrTransferPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createUpdateRoutingOrTransfer());
};
